import React, { useEffect, useRef, useState } from 'react';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import { BsFunnel } from 'react-icons/bs';
import { HamburgerMenuIcon } from '@radix-ui/react-icons';
import { FilterSelection } from '../shared/filters/filter-selection';
import { getStoredFilter } from '../shared/filters/filter-common';

export const DashboardFilter = ({ filterKey, filterUpdatedCallback, filterUpdated }) => {
  const filterRef = useRef(null);
  const [filterInUse, setFilterInUse] = useState(false);
  const [showFilterSelection, setShowFilterSelection] = useState(false);
  const [displayName, setDisplayName] = useState('');
  const [funnelColor, setFunnelColor] = useState('white');
  const [filterItemsWidth, setFilterItemsWidth] = useState(0);

  const filterChangedCallback = (filterId) => {
    const filter = getStoredFilter(filterId);
    if (!filter.allSelected) {
      setFilterInUse(true);
    } else {
      setFilterInUse(false);
    }
    filterUpdatedCallback(filterId);
  };

  // StackOverFlow https://stackoverflow.com/questions/32553158/detect-click-outside-react-component?page=1&tab=scoredesc#tab-top
  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowFilterSelection(false);
        }
      }

      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  useOutsideAlerter(filterRef);

  const showFilter = () => {
    setShowFilterSelection(true);
  };

  useEffect(() => {
    if (filterInUse) {
      setFunnelColor('black');
    } else {
      setFunnelColor('white');
    }
  }, [filterInUse]);

  useEffect(() => {
    if (filterUpdated !== filterKey) {
      const filter = getStoredFilter(filterKey);
      if (!filter.allSelected) {
        setFilterInUse(true);
      } else {
        setFilterInUse(false);
      }
    }
  }, [filterUpdated]);

  useEffect(() => {
    const filter = getStoredFilter(filterKey);
    setDisplayName(filter.displayName);
    let maxWidth = 0;
    if (!filter.allSelected) {
      setFilterInUse(true);
    }
    filter.items.forEach((item) => {
      if (item.value.length > maxWidth) {
        maxWidth = item.value.length;
      }
    });
    setFilterItemsWidth(maxWidth);
  }, []);

  return (
    <Stack direction="horizontal" className="p-0">
      <div className="ps-2">{`${displayName}`}</div>
      <div className={`ps-2 pe-1 text-${funnelColor}`}>
        <BsFunnel className="pt-0" />
      </div>
      <div className="align-content-end position-relative">
        <Button className="border-0 bg-white text-smaller dashboard-filter-button" onClick={showFilter}>
          <HamburgerMenuIcon />
        </Button>
        {showFilterSelection && (
          <div
            className="position-absolute bg-white z-index-1 ag-theme-alpine border border-2 overflow-auto"
            style={{ width: `${filterItemsWidth}rem`, maxHeight: '65vh' }}
            ref={filterRef}
          >
            <FilterSelection filterId={filterKey} filterChangedCallback={filterChangedCallback} aggrid={false} />
          </div>
        )}
      </div>
    </Stack>
  );
};
